module.exports = __webpack_public_path__ + "img/wholesale1.da9884a2.png";